module.exports = __webpack_public_path__ + "static/media/herramienta-verde.e669f7a2.svg";